import { useCallback } from 'react';

import { resolveBackendPath } from '../utils/backendUrl';
import { useOperatorConfig } from './useOperatorConfig';
import { useAuth } from './useAuth';

export function useApiClient() {
  const {
    config: { backendUrl },
  } = useOperatorConfig();
  const { session } = useAuth();

  return useCallback(
    async (path: string, init: RequestInit = {}) => {
      const headers = new Headers(init.headers ?? {});
      const hasBody = typeof init.body !== 'undefined' && !(init.body instanceof FormData);
      if (hasBody && !headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
      }
      if (session?.token) {
        headers.set('Authorization', `Bearer ${session.token}`);
      }

      return fetch(resolveBackendPath(path, backendUrl), {
        ...init,
        headers,
      });
    },
    [backendUrl, session?.token],
  );
}
